import { render, staticRenderFns } from "./titlePage.vue?vue&type=template&id=61ccfdcd&scoped=true"
import script from "./titlePage.vue?vue&type=script&lang=js"
export * from "./titlePage.vue?vue&type=script&lang=js"
import style0 from "./titlePage.vue?vue&type=style&index=0&id=61ccfdcd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ccfdcd",
  null
  
)

export default component.exports